import * as React from 'react';
import { IconProps, SIZE_MAP } from '../types';
import { cn } from '../../../utils/cn';

const UploadIcon = ({ size = 'lg', className, ...props }: IconProps) => {
  const px = SIZE_MAP[size];

  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-primary', className)}
      {...props}
    >
      <path 
        d="M19 7.75C19.4142 7.75 19.75 8.08579 19.75 8.5V17.2002C19.75 18.0278 19.751 18.6936 19.707 19.2314C19.6624 19.7781 19.5671 20.2579 19.3408 20.7021C18.9813 21.4078 18.4078 21.9813 17.7021 22.3408C17.2579 22.5671 16.7781 22.6624 16.2314 22.707C15.6936 22.751 15.0278 22.75 14.2002 22.75H9.7998C8.97222 22.75 8.30638 22.751 7.76855 22.707C7.22195 22.6624 6.74205 22.5671 6.29785 22.3408C5.59225 21.9813 5.0187 21.4078 4.65918 20.7021C4.43286 20.2579 4.33763 19.7781 4.29297 19.2314C4.24903 18.6936 4.25 18.0278 4.25 17.2002V8.5C4.25 8.08579 4.58579 7.75 5 7.75H19Z" 
        fill="currentColor"
      />
      <path 
        d="M9.25 18V13C9.25 12.5858 9.58579 12.25 10 12.25C10.4142 12.25 10.75 12.5858 10.75 13V18C10.75 18.4142 10.4142 18.75 10 18.75C9.58579 18.75 9.25 18.4142 9.25 18ZM13.25 18V13C13.25 12.5858 13.5858 12.25 14 12.25C14.4142 12.25 14.75 12.5858 14.75 13V18C14.75 18.4142 14.4142 18.75 14 18.75C13.5858 18.75 13.25 18.4142 13.25 18Z" 
        fill="white"
      />
      <path 
        d="M12.7998 1.25C13.3475 1.25 13.8037 1.24897 14.1748 1.2793C14.5545 1.31033 14.9109 1.37809 15.248 1.5498C15.7655 1.81346 16.1865 2.23451 16.4502 2.75195C16.6219 3.08909 16.6897 3.44546 16.7207 3.8252C16.751 4.19632 16.75 4.65252 16.75 5.2002V5.25H21C21.4142 5.25 21.75 5.58579 21.75 6C21.75 6.41421 21.4142 6.75 21 6.75H3C2.58579 6.75 2.25 6.41421 2.25 6C2.25 5.58579 2.58579 5.25 3 5.25H7.25V5.12012C7.25045 5.07082 7.25214 5.0004 7.25391 4.91504C7.25744 4.74495 7.26403 4.5121 7.27832 4.26367C7.2925 4.01722 7.31488 3.74366 7.34961 3.49707C7.37989 3.28211 7.43234 2.98266 7.5498 2.75195C7.81346 2.23451 8.23451 1.81346 8.75195 1.5498C9.0891 1.37809 9.44546 1.31033 9.8252 1.2793C10.1963 1.24897 10.6525 1.25 11.2002 1.25H12.7998Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default UploadIcon;
